import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_105: FaireProductEntity = {
  token: "catalog_prod_prod-105",
  type: "product",
  name: "Tabletop Accessory - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 96.07,
  msrpDollars: 240.18,
  sku: "CA0105",
  caseSize: 3,
  material: "Wood",
  collectionToken: "col_camp",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 349,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_throw-pillows"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
